import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import onClickOutside from "react-onclickoutside";

import TwoLabelSwitch from "../Switch/TwoLabelSwitch";

import SubItems from "./SubItems";
import UserItems from "./UserItems";
import GeoItems from "./GeoItems";

import "./PlusControl.scss";

import * as perm from "../../utils/perm";

import { gradeStatusOptions } from "../../constants";

const STATE_TRANSLATION = "area";
const STATE_DEVICES = "device";
const STATE_PAYMENTS = "payout_status";
const STATE_GRADE = "grade_status";
const STATE_GEO = "geo";
const STATE_AUTHOR = "user";
const STATE_MPAA_RATING = "mpaa_rating";
const STATE_HAS_DISCLAIMER = "has_disclaimer";

export const TYPE_ALL = 0;
export const TYPE_TOP = 1;
export const TYPE_INFORMER = 2;

const TRANSLATION_OPTIONS = [
  { name: "Везде", value: TYPE_ALL },
  { name: "В Топе", value: TYPE_TOP },
  { name: "В Инф", value: TYPE_INFORMER }
];

export const TYPE_MOBILE = "mobile";
export const TYPE_TABLET = "tablet";
export const TYPE_PC = "pc";

const DEVICE_OPTIONS = [
  { name: "Мобильные", value: TYPE_MOBILE },
  { name: "Планшеты", value: TYPE_TABLET },
  { name: "ПК", value: TYPE_PC }
];

export const PAYOUT_SUCCESS = 1;
export const PAYOUT_FAIL = 2;
export const PAYOUT_PENALTY = 3;
export const PAYOUT_EDIT = 4;
export const PAYOUT_WAIT = 5;

const PAYMENT_OPTIONS = [
  { name: "ОК", value: PAYOUT_SUCCESS },
  { name: "Ошибка", value: PAYOUT_EDIT },
  { name: "Отказ", value: PAYOUT_FAIL },
  { name: "Штраф", value: PAYOUT_PENALTY },
  { name: "В процессе", value: PAYOUT_WAIT }
];

const GRADE_OPTIONS = gradeStatusOptions.map(o => {
  o.name = o.label;
  return o;
});

const defaultFilters = {
  status: "",
  category: "",
  area: "",
  device: "",
  cid: "",
  user: "",
  geo: "",
  payout_status: "",
  grade_status: ""
};

const TEMPLATES = [
  {
    name: "Товарная выдача (мобильная)",
    filters: Object.assign({}, defaultFilters, { geo: 1, author: 1 })
  },
  {
    name: "Товарная выдача (десктоп)",
    filters: Object.assign({}, defaultFilters, { geo: 2, devices: 1 })
  },
  {
    name: "Реклама на обмене",
    filters: Object.assign({}, defaultFilters, {
      geo: 3,
      translation: TYPE_ALL
    })
  }
];

const isEqual = (templateFilters, filters) => {
  let eq = true;

  Object.keys(templateFilters).forEach(key => {
    if (templateFilters[key] != filters[key]) {
      eq = false;
      return;
    }
  });

  return eq;
};

export class PlusControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, menu: null };
  }

  handleClickOutside = () => {
    this.close();
  };

  open = () => {
    this.setState({ open: true });
  };

  toggle = () => {
    this.setState(prev => {
      return { open: !prev.open };
    });
  };

  close = () => {
    this.setState({ open: false, menu: null });
  };

  onBack = () => {
    this.setState({ menu: null });
  };

  openMenu = menu => {
    this.setState({ menu });
  };

  onFilterSelect = (value, shouldClose = true) => {
    this.props.onFilterChange(value);

    if (shouldClose) {
      this.close();
    }
  };

  hasSelectedItems = menu => {
    return (
      this.props.selectedFilters.hasOwnProperty(menu) &&
      !!this.props.selectedFilters[menu]
    );
  };

  isTemplateMatch = templateFilters => {
    return isEqual(templateFilters, this.props.selectedFilters);
  };

  getRootOptions = () => {
    const options = [];

    if (perm.allowAreaFilter(this.props.permissions)) {
      options.push({ name: "Область трансляции", menu: STATE_TRANSLATION });
    }

    if (perm.allowDeviceFilter(this.props.permissions)) {
      options.push({ name: "Устройства", menu: STATE_DEVICES });
    }

    if (perm.allowPaymentFilter(this.props.permissions)) {
      options.push({ name: "Статус оплаты", menu: STATE_PAYMENTS });
      options.push({ name: "Статус оценки", menu: STATE_GRADE });
    }

    if (perm.allowGeoFilter(this.props.permissions)) {
      options.push({ name: "География", menu: STATE_GEO });
    }

    if (true || perm.allowAnyAuthorFilter(this.props.permissions)) {
      options.push({ name: "Автор", menu: STATE_AUTHOR });
    }

    options.push(
      { name: "Рейтинг MPA", menu: STATE_MPAA_RATING },
      { name: "Дисклеймер", menu: STATE_HAS_DISCLAIMER }
    );

    return options;
  };

  renderControls = () => {
    const options = this.getRootOptions();

    return (
      <div className="plus-control__controls">
        {options.map(option => (
          <div
            key={option.menu}
            className={classnames("plus-control__item arrow", {
              active:
                option.menu === STATE_HAS_DISCLAIMER
                  ? false
                  : this.hasSelectedItems(option.menu)
            })}
            onClick={() => {
              this.openMenu(option.menu);
            }}
          >
            {option.name}
          </div>
        ))}

        <div className="plus-control__item-section">
          <div className="plus-control__switch-container">
            <TwoLabelSwitch
              checked={this.props.showUrl}
              labelOn="URL"
              labelOff="TXT"
              onChange={this.props.onUrlShowChange}
              size="small"
            />
          </div>
        </div>

        <div className="plus-control__item-section">
          <div className="plus-control__switch-container">
            <TwoLabelSwitch
              checked={this.props.showDisclaimer}
              labelOn="С дисклеймером"
              labelOff="Без"
              onChange={this.props.onDisclaimerShowChange}
              size="small"
            />
          </div>
        </div>

        {/*<div className="plus-control__item-section">*/}
        {/*  <div className="plus-control__switch-container">*/}
        {/*    <TwoLabelSwitch*/}
        {/*      checked={this.props.hasDisclaimer}*/}
        {/*      labelOn="С дисклеймером"*/}
        {/*      labelOff="Без"*/}
        {/*      onChange={this.props.onHasDisclaimerChange}*/}
        {/*      size="small"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}

        {perm.allowTemplates(this.props.permissions) && (
          <React.Fragment>
            <div className="plus-control__item-section template">Шаблоны</div>
            {TEMPLATES.map(option => (
              <div
                key={option.name}
                className={classnames("plus-control__item shifted", {
                  active: this.isTemplateMatch(option.filters)
                })}
                onClick={() => this.onFilterSelect(option.filters)}
              >
                {option.name}
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    );
  };

  renderSubItems = (options, value, name, title) => {
    const getValue = () => {
      if (name !== STATE_HAS_DISCLAIMER) {
        return value;
      }

      if (value === "" || value === undefined) {
        return 0;
      }

      return value === "true" || value === true ? 1 : 2;
    };

    return (
      <SubItems
        onBack={this.onBack}
        options={options}
        value={getValue()}
        onSelect={details => {
          if (name === STATE_HAS_DISCLAIMER) {
            const getValue = () => {
              const value = details[STATE_HAS_DISCLAIMER];

              if (value === 0) {
                return undefined;
              }

              return value === 1;
            };

            this.onFilterSelect({
              has_disclaimer: getValue()
            });
          } else {
            this.onFilterSelect(details);
          }
        }}
        title={title}
        name={name}
      />
    );
  };

  renderMenu = () => {
    const mpaaRatings = [
      { id: 0, name: "Без рейтинга" },
      ...this.props.mpaaRatings
    ].map(({ id: value, name }) => ({
      name,
      value
    }));

    switch (this.state.menu) {
      case STATE_TRANSLATION:
        return this.renderSubItems(
          TRANSLATION_OPTIONS,
          parseInt(this.props.selectedFilters.area),
          STATE_TRANSLATION,
          "Область трансляции"
        );
      case STATE_DEVICES:
        return this.renderSubItems(
          DEVICE_OPTIONS,
          this.props.selectedFilters.device,
          STATE_DEVICES,
          "Устройства"
        );
      case STATE_PAYMENTS:
        return this.renderSubItems(
          PAYMENT_OPTIONS,
          this.props.selectedFilters.payout_status,
          STATE_PAYMENTS,
          "Статус оплаты"
        );
      case STATE_GRADE:
        return this.renderSubItems(
          GRADE_OPTIONS,
          this.props.selectedFilters.grade_status,
          STATE_GRADE,
          "Статус оценки"
        );
      case STATE_GEO:
        return (
          <GeoItems
            title="География"
            onBack={this.onBack}
            value={this.props.selectedFilters.geo}
            onSelect={this.onFilterSelect}
            name="geo"
          />
        );
      case STATE_AUTHOR:
        return (
          <UserItems
            title="Авторы"
            onBack={this.onBack}
            options={this.props.authorOptions}
            value={this.props.selectedFilters.user}
            onSelect={this.onFilterSelect}
            onUserSelect={this.props.onUserSelect}
            name="user"
            permissions={this.props.permissions}
          />
        );
      case STATE_MPAA_RATING:
        return this.renderSubItems(
          mpaaRatings,
          this.props.selectedFilters.mpaa_rating,
          STATE_MPAA_RATING,
          "Рейтинг MPA"
        );
      case STATE_HAS_DISCLAIMER:
        return this.renderSubItems(
          [
            { name: "Все", value: 0 },
            { name: "С дисклеймером", value: 1 },
            { name: "Без дисклеймера", value: 2 }
          ],
          this.props.selectedFilters.has_disclaimer,
          STATE_HAS_DISCLAIMER,
          "Дисклеймер"
        );
      default:
        return this.renderControls(this.props.selectedFilters);
    }
  };

  render() {
    return (
      <div className={classnames("plus-control", { open: this.state.open })}>
        <div className="plus-control__button" onClick={this.toggle} />
        {this.state.open && this.renderMenu()}
      </div>
    );
  }
}

PlusControl.propTypes = {
  selectedFilters: PropTypes.object,
  showOt: PropTypes.bool,
  showUrl: PropTypes.bool,
  showDisclaimer: PropTypes.bool,

  authorOptions: PropTypes.array,
  geoOptions: PropTypes.array,

  onFilterChange: PropTypes.func.isRequired,
  onCtShowChange: PropTypes.func.isRequired,
  onUrlShowChange: PropTypes.func.isRequired,
  onDisclaimerShowChange: PropTypes.func.isRequired,
  onUserSelect: PropTypes.func.isRequired,
  permissions: PropTypes.array
};

PlusControl.defaultProps = {
  selectedFilters: {},
  showOt: false,
  showUrl: false,

  authorOptions: [],
  geoOptions: [],
  permissions: []
};

export default onClickOutside(PlusControl);
